import { formatISO } from 'date-fns';
import { useGetHealthMetricsV3 } from '#hooks/use-get-health-metrics-v3.hook.ts';

type UseChartDataParams = {
  metric: string;
  from: Date;
};

export function useChartData(
  { metric, from }: UseChartDataParams,
  queryOptions?: { enabled: boolean },
) {
  const useGetHealthMetricsQuery = useGetHealthMetricsV3(
    {
      interval: 'all',
      filter: { type: metric },
      fields: { type: ['type', 'value', 'unit', 'timestamp'] },
      from: formatISO(from, { representation: 'date' }),
    },
    queryOptions,
  );

  return useGetHealthMetricsQuery;
}
